import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogConfirmData {
    headline: string;
    body: string;
    btn: string;
    warning?: string;
}

/**
 * Dialog for confirming an action.
 */
@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
    standalone: false
})
export class DialogConfirmComponent {
    constructor(
        public readonly dialogRef: MatDialogRef<DialogConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: DialogConfirmData,
    ) {}
}
